import { createTheme } from "@mui/material/styles";

const fontFamily = ["Arimo", "sans-serif"].join(",");

declare module "@mui/material/styles" {
  interface PaletteOptions {
    gradient: {
      main: string;
      mainGradient: string;
      mainChannel: string;
      toTop: string;
      toTopChannel: string;
      dark: string;
      darkChannel: string;
      light: string;
      lightChannel: string;
      contrastText: string;
      contrastTextChannel: string;
    };
  }

  interface Palette {
    gradient: {
      main: string;
      mainGradient: string;
      toTop: string;
      dark: string;
      light: string;
      contrastText: string;
    };
  }
}

export const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 600,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    h1: { fontFamily, color: "#000000" },
    h2: { fontFamily, color: "#000000" },
    h3: { fontFamily, color: "#000000" },
    h4: { fontFamily, color: "#000000" },
    h5: { fontFamily, color: "#000000" },
    h6: { fontFamily, color: "#000000" },
    subtitle1: { fontFamily },
    subtitle2: { fontFamily },
    body1: { fontFamily, color: "#393939" },
    body2: { fontFamily, color: "#393939" },
    button: {
      fontFamily,
      fontWeight: "700",
      fontSize: "18px",
      textTransform: "none",
    },
    caption: { fontFamily },
    overline: { fontFamily },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
      },
    },
  },
  palette: {
    mode: "light",
    primary: {
      main: "#466A88",
      contrastText: "#fff",
    },
    secondary: {
      main: "#FFFFFF",
      contrastText: "#000000",
    },
    background: {
      default: "#F2F1ED",
      paper: "#FFFFFF",
    },
    text: {
      primary: "#393939",
    },
    gradient: {
      main: "#59E8C6",
      mainGradient: "#43527D",
      mainChannel: "0 0 0",
      toTop: "linear-gradient(90deg, #59E8C6 0%, #43527D 100%)",
      toTopChannel: "0 0 0",
      dark:
        "linear-gradient(to top,  #130021  0%, #2A2A2A  100%), linear-gradient(180deg, #130021  0%, #2A2A2A  100%)",
      darkChannel: "0 0 0",
      light: "#F2F1ED",
      lightChannel: "0 0 0",
      contrastText: "#fff",
      contrastTextChannel: "0 0 0",
    },
  },
});

export const darkTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 600,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    h1: { fontFamily },
    h2: { fontFamily },
    h3: { fontFamily },
    h4: { fontFamily },
    h5: { fontFamily },
    h6: { fontFamily },
    subtitle1: { fontFamily },
    subtitle2: { fontFamily },
    body1: { fontFamily },
    body2: { fontFamily },
    button: {
      fontFamily,
      fontWeight: "700",
      fontSize: "18px",
      textTransform: "none",
    },
    caption: { fontFamily },
    overline: { fontFamily },
  },
  palette: {
    mode: "dark",
    primary: {
      main: "#fff",
      contrastText: "#000",
    },
    secondary: {
      main: "#525d72",
      contrastText: "#000",
    },
    gradient: {
      main: "#130021",
      mainGradient: "#21293C",
      mainChannel: "0 0 0",
      toTop:
        "linear-gradient(to top,  #FF6663  0%, #FFC857  100%), linear-gradient(180deg, #FF6663  0%, #FFC857 100%);",
      toTopChannel: "0 0 0",
      dark: "linear-gradient(to top,  #130021  0%, #1d0133  100%), linear-gradient(180deg, #130021  0%, #1d0133  100%)",
      darkChannel: "0 0 0",
      light: "#272729",
      lightChannel: "0 0 0",
      contrastText: "#fff",
      contrastTextChannel: "0 0 0",
    },
  },
});
